import React from 'react';
import { Nav } from '@components';
import { Eye, EyeOff } from 'react-feather';
import { useAuth } from '@hooks/useAuth';
import { LoaderContext } from '../../App';
import { LoaderOverlay } from '@components';

const Signin = () => {
  document.title = 'ProWebTrade - Signin';
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [password, setPassword] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState(null);

  const [emailError, setEmailError] = React.useState(null);
  const [passwordError, setPasswordError] = React.useState(null);

  const { signin, user, loading } = useAuth();
  const { setLoading } = React.useContext(LoaderContext);
  React.useEffect(() => {
    setLoading(loading);
  }, [loading]);

  if (user) {
    return window.location.replace('/dashboard/?view=dashboard');
  }

  const sign = async (e) => {
    e.preventDefault();

    setEmailError(null);
    setPasswordError(null);

    let isError = false;

    // Validating email
    if (!email || email.trim().length === 0) {
      setEmailError('Email is required');

      isError = true;
    } else if (!email.includes('@')) {
      setEmailError('Email is invalid');

      isError = true;
    }

    // Validating password
    if (!password || password.length === 0) {
      setPasswordError('Password is required');
      isError = true;
    } else if (password.length < 8) {
      setPasswordError('Password must be at least 8 characters');
      isError = true;
    } else if (!/\d/.test(password)) {
      setPasswordError('Password must contain at least one number');
      isError = true;
    } else if (!/[a-z]/.test(password)) {
      setPasswordError('Password must contain at least one lowercase letter');
      isError = true;
    } else if (!/[A-Z]/.test(password)) {
      setPasswordError('Password must contain at least one uppercase letter');
      isError = true;
    } else if (!/[^A-Za-z0-9]/.test(password)) {
      setPasswordError('Password must contain at least one symbol');
      isError = true;
    }

    if (isError) {
      return null;
    }

    const res = await signin(email, password);
    if (res?.message || res?.error)
      setError(res.error ? res.error : res.message);
    else {
      window.location.replace('/dashboard/?view=dashboard');
    }
  };

  return !user ? (
    <section className="auth_page">
      {loading && <LoaderOverlay />}
      <Nav hide="signin" />
      <main className="auth_container">
        <div className="auth_title">
          <h1 className="auth_title">Sign in</h1>
        </div>
        <form className="auth_form">
          <div className="auth_form_group">
            <label htmlFor="email">Email</label>
            <input
              onFocus={() => setError(null)}
              type="email"
              id="email"
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              placeholder="Enter your email"
              className={emailError ? '!border-2 !border-red-700' : ''}
            />
            {emailError && <p className="error">{emailError}</p>}
          </div>
          <div className="auth_form_group">
            <label htmlFor="password">Password</label>
            <div className="password_input">
              <input
                onFocus={() => setError(null)}
                type={passwordVisible ? 'text' : 'password'}
                autoCorrect="off"
                autoCapitalize="none"
                autoComplete="off"
                autoSave="off"
                id="password"
                name="password"
                onChange={(e) => setPassword(e.target.value)}
                className={passwordError ? '!border-2 !border-red-700' : ''}
                value={password}
                placeholder="Enter your password"
              />
              <div className="eye_container">
                {passwordVisible ? (
                  <EyeOff
                    style={{ cursor: 'pointer' }}
                    color="rgba(119, 237, 145, .2)"
                    className="password_toggle"
                    onClick={() => setPasswordVisible(false)}
                  />
                ) : (
                  <Eye
                    style={{ cursor: 'pointer' }}
                    color="rgba(119, 237, 145, 1)"
                    className="password_toggle"
                    onClick={() => setPasswordVisible(true)}
                  />
                )}
              </div>
            </div>
            {passwordError && <p className="error">{passwordError}</p>}
          </div>
          {error && <p className="error">{error}</p>}
          <button onClick={sign}>Sign in</button>
          <a href="/auth/reset" className="green">
            Forgot your password?
          </a>
        </form>
      </main>
    </section>
  ) : (
    <></>
  );
};

export default Signin;
